import { render } from "./SweetAlerts.vue?vue&type=template&id=de328222"
import script from "./SweetAlerts.vue?vue&type=script&lang=js"
export * from "./SweetAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__